import React from "react";
import { Dialog, DialogContent, Avatar, Typography, Box, Button } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

const ViewReportsModal = ({ open, onClose, report }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                    padding: "24px",
                }
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    Report Details
                </Typography>
                <Button onClick={onClose} sx={{ minWidth: "auto", p: 0 }}>
                    <IoClose size={24} />
                </Button>
            </Box>

            <DialogContent>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                        Post Owner
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Avatar
                            src={report?.Post?.postOwner?.profileImage}
                            sx={{ width: 56, height: 56 }}
                        />
                        <Typography>
                            {report?.Post?.postOwner?.first_name} {report?.Post?.postOwner?.last_name}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                        Reported Content
                    </Typography>
                    {report?.Post?.post?.includes('.mp4') ? (
                        <video
                            controls
                            src={report?.Post?.post}
                            style={{ width: "100%", borderRadius: "8px" }}
                        />
                    ) : (
                        <PhotoProvider>
                            <PhotoView src={report?.Post?.post}>
                                <img
                                    src={report?.Post?.post}
                                    alt="Reported post"
                                    style={{
                                        width: "100%",
                                        maxHeight: "400px",
                                        objectFit: "contain",
                                        borderRadius: "8px",
                                        cursor: "pointer"
                                    }}
                                />
                            </PhotoView>
                        </PhotoProvider>
                    )}
                    {report?.Post?.caption && (
                        <Typography sx={{ mt: 2 }}>
                            {report?.Post?.caption}
                        </Typography>
                    )}
                </Box>

                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                        Reason for Report
                    </Typography>
                    <Typography sx={{
                        p: 2,
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px"
                    }}>
                        {report?.PostReportOption?.report}
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ViewReportsModal;